import { createEvent, createStore } from "effector";

export const setIsFullscreen = createEvent<boolean>("setIsFullscreen")
export const $isFullscreen = createStore<boolean>(false).on(setIsFullscreen, (_, val) => val)